import type { HelpFile } from '../../types/help'
import { FormLayoutDesignerPageTestIds } from '../../../testids/FormLayoutDesignerPageTestIds'

export const formLayoutDesignerPageHelp: HelpFile = {
  docPage: '/docs/schema/form-layouts',
  texts: {
    [FormLayoutDesignerPageTestIds.formLayoutDesignerPage]:
      'Visual designer for arranging the fields, sections, and tabs of a form layout used by an entity type.',
    [FormLayoutDesignerPageTestIds.designerCancelBtn]:
      'Discard changes and return to the layout list.',
    [FormLayoutDesignerPageTestIds.designerSaveBtn]:
      'Save the current layout — the new arrangement is published to all users immediately.',
    [FormLayoutDesignerPageTestIds.usedOnPageLink]:
      'Open the page or entity that currently uses this layout to verify the rendering.',
    [FormLayoutDesignerPageTestIds.unsavedChangesDialog]:
      'Confirms whether to leave the designer without saving — the dialog appears when you click Cancel with unsaved changes.',
    [FormLayoutDesignerPageTestIds.unsavedChangesStayBtn]:
      'Stay on the page and continue editing — your unsaved changes are preserved.',
    [FormLayoutDesignerPageTestIds.unsavedChangesLeaveBtn]:
      'Leave without saving — the unsaved changes are discarded.',
    [FormLayoutDesignerPageTestIds.conflictDialog]:
      'Indicates that another user saved this layout while you were editing — pick a recovery action.',
    [FormLayoutDesignerPageTestIds.conflictKeepEditingBtn]:
      'Keep editing your version — the conflicting save remains visible to others until you save again.',
    [FormLayoutDesignerPageTestIds.conflictDiscardBtn]:
      'Discard your local changes and reload the layout from the server.',
  },
}
